import { render, staticRenderFns } from "./city-button.vue?vue&type=template&id=1f2b457c&scoped=true&"
import script from "./city-button.vue?vue&type=script&lang=js&"
export * from "./city-button.vue?vue&type=script&lang=js&"
import style0 from "./city-button.vue?vue&type=style&index=0&id=1f2b457c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2b457c",
  null
  
)

export default component.exports